// Configuration file for the application

// API Configuration
// API_URL is dynamically set by Azure pipeline during build for production
// For local development, it uses the value from .env file
// For local development with proxy, use empty string to let proxy handle it
// Or fallback to localhost:8000 if not using proxy
export const API_URL = process.env.REACT_APP_API_URL || '';

// API_KEY for authentication
// Production value is injected during build by Azure pipeline
// For local development, use a development-only key
export const API_KEY = process.env.REACT_APP_API_KEY || 'dev-key-local-only';

// Azure Function URL
// Production: Set REACT_APP_AZURE_FUNCTION_URL in Azure pipeline
// Local: Uses localhost:7071 (default Azure Functions Core Tools port)
export const AZURE_FUNCTION_URL = process.env.REACT_APP_AZURE_FUNCTION_URL || 'http://localhost:7071/api';
